import Cookies from 'js-cookie'
import Splide from '@splidejs/splide';

const COOKIE_NAME = 'MessageCarouselClosed'
const EL_SELECTOR = '.js-MessageCarousel'
const EL = document.querySelector(EL_SELECTOR)
const COOKIE_EXPIRES_DAYS = 7

class MessageCarousel {
  constructor() {
    if(!Cookies.get(COOKIE_NAME) && EL){
      this.init()
      this.show()
    }
  }

  show = () => {
    EL.classList.remove('not-loaded')
  }

  setCloseCookie = () => {
    Cookies.set(COOKIE_NAME, 'true', { expires: COOKIE_EXPIRES_DAYS })
  }

  init = () => {
    const close = EL.querySelector('.message__close')

    new Splide( EL, {
      arrows: false,
      pagination: true,
      perMove: 1,
    } ).mount();

    close.addEventListener('click', (e) => {
      const button = e.currentTarget
      const parent = button.closest(EL_SELECTOR)

      this.setCloseCookie()

      parent.classList.add('is-hidden')
    })
  }
}

new MessageCarousel();
